import { useState } from "react";
import { useDispatch } from "react-redux";
import { authAction } from "../../../store/User/AuthSlice";
import Profile from "../../../assets/profile.png";
import NavList from "./NavList";
import Logo from "../Logo/Logo";
import {
  FaUserAlt,
  FaBoxOpen,
  FaChartBar,
  FaIndustry,
  FaWarehouse,
  FaMoneyBillWaveAlt,
  FaBox,
  FaProductHunt,
  FaStickerMule,
} from "react-icons/fa";
import { BiHomeAlt } from "react-icons/bi";
import Dropshadow from "../Dropshadow";

import { useNavigate, useLocation } from "react-router-dom";
import {
  MdMenu,
  MdLogout,
  MdOutlineBusiness,
  MdPayments,
  MdSource,
  MdOutbox,
  MdOutlineCancel,
  MdOutlineHighQuality,
  MdHighQuality,
} from "react-icons/md";

import { GiPapers, GiJoint } from "react-icons/gi";
import { GrUserSettings } from "react-icons/gr";
import { GetActiveLink } from "../../../utility/GetActiveLink";
const Nav = () => {
  const location = useLocation();

  const [isOpenNav, setIsOpenNav] = useState(false);
  const [navLinkActive, setNavLinkActive] = useState(
    GetActiveLink(location.pathname) //utility function to get name for active link
  );

  const dispatch = useDispatch();
  const history = useNavigate();
  // function to open and close menu
  const onChangeNav = () => {
    setIsOpenNav((preState) => !preState);
  };
  const onNavLinkActiveHandler = (data) => {
    setNavLinkActive(data);
  };

  const onLogoutHandler = () => {
    // dispatch(authAction.logout());
    history("/login");
  };

  //css style for active nav link
  const cssActiveStyle = "bg-btnbgcolor text-bgwhite rounded";
  return (
    <nav
      className={`bg-bgdarkgrey   ${
        !isOpenNav && "w-[60px]"
      }   flex flex-col  md:w-[auto]  justify-between fixed z-10 top-0 bottom-0 md:fixed h-screen overflow-hidden `}
    >
      <div
        className={`bg-bgdarkgrey md:py-3 md:px-5 z-10 w-full ${
          !isOpenNav ? " px-0.5 py-0.5" : "px-10 py-3"
        } overflow-y-scroll custom-scroll-for-nav`}
      >
        {isOpenNav && (
          <Dropshadow onDropDownToggle={onChangeNav} dropDownStyle="z-1" />
        )}
        {/* toggle buttons */}
        <span
          onClick={onChangeNav}
          className={`absolute ${
            !isOpenNav
              ? "w-full flex justify-center bg-bgdarkgrey top-0"
              : "top-[2%] right-[7%]"
          }  md:top-[1%] md:right-[7%] text-3xl cursor-pointer hover:scale-110 md:hidden`}
        >
          {!isOpenNav ? <MdMenu /> : <MdOutlineCancel />}
        </span>

        <div className=" mt-2 ">
          <Logo />
          {/* <div className="mb-4">
            <div className={`rounded-full  mb-3 max-w-[180px]  w-[50%] m-auto`}>
              <img
                src={Profile}
                alt="profileimg"
                className="w-full rounded-full"
              />
            </div>
            <div className="text-center">
              <h3
                className={`text-md font-bold  'w-[80%]  ${
                  !isOpenNav ? "hidden" : "block"
                } md:block`}
              >
                Mandu Paudel
              </h3>
              <span
                className={`text-btnbgcolor text-sm font-medium ${
                  !isOpenNav ? "hidden" : "block"
                } md:block`}
              >
                Admin
              </span>
            </div>
          </div> */}
          <ul>
            {/* url name need to be same as navLinkActive */}
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/"}
              urlName="Reports"
              cssActiveStyle={navLinkActive === "Reports" ? cssActiveStyle : ""}
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaChartBar />
              </span>
            </NavList>
          
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/products"}
              urlName="Products"
              cssActiveStyle={
                navLinkActive === "Products" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <BiHomeAlt />
              </span>
            </NavList>

            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/vendor"}
              urlName="Vendor"
              cssActiveStyle={navLinkActive === "Vendor" ? cssActiveStyle : ""}
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaWarehouse />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/users"}
              cssActiveStyle={navLinkActive === "User" ? cssActiveStyle : ""}
              urlName="User"
            >
              <span className="flex items-center mr-2 text-xl">
                <FaUserAlt />
              </span>
            </NavList>
          
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/operator"}
              cssActiveStyle={
                navLinkActive === "Operator" ? cssActiveStyle : ""
              }
              urlName="Operator"
            >
              <span className="flex items-center mr-2 text-xl">
                <GrUserSettings />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/production"}
              urlName="Production"
              cssActiveStyle={
                navLinkActive === "Production" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaProductHunt />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/mold"}
              cssActiveStyle={navLinkActive === "Mold" ? cssActiveStyle : ""}
              urlName="Mold"
            >
              <span className="flex items-center mr-2 text-xl">
                <GiJoint />
              </span>
            </NavList>

            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              cssActiveStyle={
                navLinkActive === "Labour Cost" ? cssActiveStyle : ""
              }
              url={"/labourcost"}
              urlName="Labour Cost"
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaMoneyBillWaveAlt />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              cssActiveStyle={navLinkActive === "Quality" ? cssActiveStyle : ""}
              url={"/quality"}
              urlName="Quality"
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdOutlineHighQuality />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              cssActiveStyle={
                navLinkActive === "Sub Quality" ? cssActiveStyle : ""
              }
              url={"/subquality"}
              urlName="Sub Quality"
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdHighQuality />
              </span>
            </NavList>

            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/factory"}
              urlName="Factory"
              cssActiveStyle={navLinkActive === "Factory" ? cssActiveStyle : ""}
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaIndustry />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/leafwarehouse"}
              urlName="Leaf Ware House"
              cssActiveStyle={
                navLinkActive === "Leaf Ware House" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdOutlineBusiness />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/leafstock"}
              urlName="Leaf Stock"
              cssActiveStyle={
                navLinkActive === "Leaf Stock" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdOutlineBusiness />
              </span>
            </NavList>

            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/cartoontype"}
              urlName="Cartoon"
              cssActiveStyle={navLinkActive === "Cartoon" ? cssActiveStyle : ""}
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaBoxOpen />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/cartoonstock"}
              urlName="Cartoon Stock"
              cssActiveStyle={
                navLinkActive === "Cartoon Stock" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaBoxOpen />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/cartoonwithdraw"}
              urlName="Cartoon Withdraw"
              cssActiveStyle={
                navLinkActive === "Cartoon Withdraw" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdOutbox />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/plastictype"}
              urlName="Plastic"
              cssActiveStyle={navLinkActive === "Plastic" ? cssActiveStyle : ""}
            >
              <span className="flex  items-center mr-2 text-xl">
                <GiPapers />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/plasticstock"}
              urlName="Plastic Stock"
              cssActiveStyle={
                navLinkActive === "Plastic Stock" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <GiPapers />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/plasticwithdraw"}
              urlName="Plastic Withdraw"
              cssActiveStyle={
                navLinkActive === "Plastic Withdraw" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <GiPapers />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/stickerstock"}
              urlName="Sticker Stock"
              cssActiveStyle={
                navLinkActive === "Sticker Stock" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaStickerMule />
              </span>
            </NavList>

            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/vendor-payment"}
              urlName="Vendor Payment"
              cssActiveStyle={
                navLinkActive === "Vendor Payment" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdPayments />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/product-outsourcing"}
              urlName="Product Outsourcing"
              cssActiveStyle={
                navLinkActive === "Product Outsourcing" ? cssActiveStyle : ""
              }
            >
              <span className="flex  items-center mr-2 text-xl">
                <MdSource />
              </span>
            </NavList>
            <NavList
              onNavLinkActiveHandler={onNavLinkActiveHandler}
              isOpenNav={isOpenNav}
              url={"/order"}
              urlName="Order"
              cssActiveStyle={navLinkActive === "Order" ? cssActiveStyle : ""}
            >
              <span className="flex  items-center mr-2 text-xl">
                <FaBox />
              </span>
            </NavList>
          </ul>
        </div>
        <div
          className={`flex ${
            !isOpenNav ? "justify-start" : "justify-center"
          } md:justify-center`}
        >
          <button
            onClick={onLogoutHandler}
            className={`font-medium text-sm hover:scale-95 duration-200 mb-4 flex items-center ${
              !isOpenNav && "pl-4"
            }  `}
          >
            <span
              className={`mt-0.5  ${!isOpenNav ? "hidden" : "block"} md:block`}
            >
              Logout
            </span>{" "}
            <span
              className={`flex items-center   text-xl  ${
                !isOpenNav ? "ml-0" : "ml-2"
              } md:ml-2`}
            >
              <MdLogout />
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};
export default Nav;
